import { useQuery } from '@tanstack/react-query';
import type { VideoAutoConfig } from '@news-cms/shared';
import { Label } from '@/components/ui/label';
import { groupContentsVideoPlaylistsQueryOptions } from '@/lib/group-contents';

interface Props {
  config: VideoAutoConfig;
  onChange: (next: VideoAutoConfig) => void;
}

export function ConfigEditorVideoAuto({ config, onChange }: Props) {
  const playlistsQuery = useQuery(groupContentsVideoPlaylistsQueryOptions);
  const playlists = playlistsQuery.data ?? [];

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="video-playlist">Playlist</Label>
        <select
          id="video-playlist"
          value={config.playlistId ?? ''}
          onChange={(e) => onChange({ ...config, playlistId: e.target.value || null })}
          className="border-input bg-background h-10 w-full rounded-md border px-3 text-sm"
        >
          <option value="">ทุก playlist</option>
          {playlists.map((pl) => (
            <option key={pl.id} value={pl.id}>
              {pl.name}
            </option>
          ))}
        </select>
        <p className="text-xs text-slate-500">ว่าง = ไม่กรอง — ดึงจากทุก playlist ที่ active</p>
      </div>

      <div className="space-y-1.5">
        <Label>เรียงตาม</Label>
        <div className="rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300">
          ล่าสุด (publishedAt desc) — fixed
        </div>
      </div>
    </div>
  );
}
